import React from "react";

import { useCommunicationSettings } from "./hooks/useCommunicationSettings";

import CommunicationHeader from "./components/CommunicationHeader";
import CommunicationKpiCards from "./components/CommunicationKpiCards";
import CommunicationSafetyNotice from "./components/CommunicationSafetyNotice";
import CommunicationPurgeCard from "./components/CommunicationPurgeCard";

export default function SettingsCommunication() {
  const dashboard = useCommunicationSettings();

  return (
    <div className="space-y-5">
      <CommunicationHeader
        refreshing={dashboard.refreshing}
        onRefresh={dashboard.fetchCounts}
      />

      <CommunicationKpiCards
        loading={dashboard.loading}
        notificationCount={dashboard.notificationCount}
        messageCount={dashboard.messageCount}
        totalCount={dashboard.totalCount}
      />

      <CommunicationSafetyNotice />

      <section className="grid gap-5 xl:grid-cols-2">
        <CommunicationPurgeCard
          type="notifications"
          title="Notifications anciennes"
          description="Supprimez les notifications système anciennes : rappels, alertes, actions de gestion ou informations devenues inutiles."
          count={dashboard.notificationCount}
          loading={dashboard.loading}
          form={dashboard.notificationsForm}
          setField={dashboard.setNotificationsField}
          submitting={dashboard.submittingNotifications}
          buttonLabel="Supprimer les notifications"
          dangerLabel="Les notifications comprises dans cette période seront supprimées définitivement."
          onSubmit={dashboard.handlePurgeNotifications}
        />

        <CommunicationPurgeCard
          type="messages"
          title="Messages anciens"
          description="Supprimez les anciens messages échangés entre utilisateurs, enseignants ou administrateurs."
          count={dashboard.messageCount}
          loading={dashboard.loading}
          form={dashboard.messagesForm}
          setField={dashboard.setMessagesField}
          submitting={dashboard.submittingMessages}
          buttonLabel="Supprimer les messages"
          dangerLabel="Les messages compris dans cette période seront supprimés définitivement."
          onSubmit={dashboard.handlePurgeMessages}
        />
      </section>
    </div>
  );
}